/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Zesty_Lemur_TalkInputs */

const fr_mild_zesty_lemur_talk = /** @type {(inputs: Mild_Zesty_Lemur_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu n'as plus de séances, merci de contacter ton coach pour rajouter des séances !`)
};

/**

* @param {Mild_Zesty_Lemur_TalkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const mild_zesty_lemur_talk = /** @type {((inputs?: Mild_Zesty_Lemur_TalkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Zesty_Lemur_TalkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_mild_zesty_lemur_talk(inputs)
});